import { useFormContext } from 'react-hook-form';
import { useStateMachine } from 'little-state-machine';

import { Input, Radio, Disqualification } from '@/components/fields';
import { useTheme } from '@/contexts/ThemeContext';

export default function ReplacementDetails(): JSX.Element {
  const { errors } = useFormContext();
  const {
    state: {
      form: { licenceNumber },
    },
  } = useStateMachine();

  const { landingPage } = useTheme();

  return (
    <>
      <div>
        {landingPage !== 'v12' && landingPage !== 'v13' && (
          <h3 className="bg-box-header text-xl leading-8 font-medium tracking-tight text-white flex items-center mb-5 py-2 px-4">
            Basic Details
          </h3>
        )}
        <div>
          <div className="px-6 py-1">
            <div className="md:flex md:items-center">
              <div className="md:w-2/5 md:pr-4">
                <span className="block text-sm leading-5 font-normal text-gray-900">
                  My licence has been{' '}
                  <sup className="text-red-600 font-sans">*</sup>
                </span>
              </div>
              <div className="md:w-2/5 md:pl-4">
                <div className="md:flex items-center">
                  <Radio name="licence_status" id="lost" className="mr-4">
                    Lost
                  </Radio>
                  <Radio name="licence_status" id="stolen" className="mr-4">
                    Stolen
                  </Radio>
                  <Radio name="licence_status" id="destroyed" className="mr-4">
                    Destroyed
                  </Radio>
                  <Radio name="licence_status" id="defaced" className="mr-4">
                    Defaced
                  </Radio>
                </div>
                {errors['licence_status'] ? (
                  <p className="mb-4 text-sm text-red-600">
                    {errors['licence_status'].message}
                  </p>
                ) : null}
              </div>
            </div>
            {!licenceNumber && (
              <div className="mt-4">
                <Input id="driver_number" isRequired={false}>
                  Your photocard driver’s licence number{' '}
                  <sup className="text-red-600 font-sans">*</sup>
                  <br />
                  <span className="font-medium text-xs text-red-600">
                    This 16 digit number can be found in section 5 e.g.
                    MORGA657054SM9IJ
                  </span>
                </Input>
                <div>
                  <img
                    src="/images/licence-number.png"
                    alt="Licence Number"
                    className="h-28"
                  />
                </div>
              </div>
            )}
            <div className="mt-4">
              <Disqualification />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
